import axios from 'axios'
import { Message } from 'element-ui'
import { getAdminToken, getParentToken, adminLogout, parentLogout } from './auth'

const request = axios.create({
  baseURL: '/api/clockout',
  timeout: 30000
})

request.interceptors.request.use(config => {
  const authType = config.authType
  if (authType === 'parent') {
    const token = getParentToken()
    if (token) config.headers.Authorization = `Bearer ${token}`
  } else if (authType === 'admin') {
    const token = getAdminToken()
    if (token) config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

function handleUnauthorized(config, message) {
  Message.error(message || '登录已过期，请重新登录')
  const authType = config && config.authType
  if (authType === 'parent') {
    parentLogout()
    if (!location.hash.includes('/parent/login')) {
      location.hash = '#/parent/login'
    }
  } else {
    adminLogout()
    if (!location.hash.includes('/login')) {
      location.hash = '#/login'
    }
  }
}

request.interceptors.response.use(
  response => {
    const res = response.data
    const cfg = response.config || {}
    if (res.code === 401) {
      handleUnauthorized(cfg, res.message)
      return Promise.reject(new Error(res.message || '未登录'))
    }
    if (res.code !== 200) {
      if (!cfg.silentBizError) {
        Message.error(res.message || '请求失败')
      }
      const err = new Error(res.message || '请求失败')
      err.bizCode = res.code
      err.bizData = res.data
      err.bizMessage = res.message
      return Promise.reject(err)
    }
    return res
  },
  error => {
    const status = error.response && error.response.status
    const msg = (error.response && error.response.data && error.response.data.message)
      || error.message
      || '网络错误'
    if (status === 401) {
      handleUnauthorized(error.config, msg)
    } else if (!(error.config && error.config.silentBizError)) {
      Message.error(msg)
    }
    return Promise.reject(error)
  }
)

export default request
